import { HypothekenAfspraakComponent } from '@ha/hypotheken-afspraak.component';
import { AppointmentResource } from '@ha/appointment.resource';
import { contentInitializer } from '@ha/content.initializer';

import { DatePipe, TitleCasePipe } from '@angular/common';
import { enableProdMode, importProvidersFrom, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';

import { ApAnalyticsModule } from '@ap/analytics';
import { ApContentService } from '@ap/content';
import { ApFormService } from '@ap/form';
import { ApContactDetailsService } from '@ap/personal-details';
import { ApDutchAddressService } from '@ap/dutch-address';

// @ts-ignore: Needs to be ignored so the typescript compiler replaces CONFIGURATION
export const configuration: string = CONFIGURATION;

if (configuration !== 'development') {
    enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
    bootstrapApplication(HypothekenAfspraakComponent, {
        providers: [
            provideZoneChangeDetection(),
            provideAppInitializer(contentInitializer),
            importProvidersFrom(ApAnalyticsModule),
            provideHttpClient(),
            ApContentService,
            ApFormService,
            ApContactDetailsService,
            ApDutchAddressService,
            AppointmentResource,
            DatePipe,
            TitleCasePipe
        ]
    }).catch((err) => console.error(err));
});
